import React, { useState, useEffect, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation, Outlet } from "react-router-dom";
import { AppContext } from "./context/AppContext";
import LoginForm from "./login/LoginForm";
import MainSidebar from "./components/MainSidebar";
import About from "./components/About";
// import Classifieds from "./components/matrimonial/Classifieds";
import PageUnderConstruction from "./components/PageUnderConstruction";
import AddNew from "./components/matrimonial/AddNew";
import View from "./components/matrimonial/View";
import PrintPreview from "./components/matrimonial/PrintPreview";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const ProtectedRoute = ({ isAuthenticated, children }) => {
  const location = useLocation();
  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const handleLogin = useCallback(
    (token) => {
      onLogin(token);
      navigate(from, { replace: true });
    },
    [onLogin, navigate, from]
  );

  return <LoginForm onLogin={handleLogin} />;
};

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
 
  const toggleSidebar = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, []);

  const handleLogin = useCallback((token) => {
    localStorage.setItem("access_token", token);
    setIsAuthenticated(true);
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      setUserRole(payload.role);
      setIsAdmin(payload.role === "admin");
    } catch (err) {
      console.error("handleLogin: Token decode failed:", err);
      localStorage.removeItem("access_token");
      setIsAuthenticated(false);
      setUserRole(null);
      setIsAdmin(false);
    }
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("access_token");
    setIsAuthenticated(false);
    setUserRole(null);
    setIsAdmin(false);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        setIsAuthenticated(true);
        setUserRole(payload.role);
        setIsAdmin(payload.role === "admin");
      } catch (err) {
        console.error("useEffect: Token validation failed:", err);
        handleLogout(); // Invalid token
      }
    }
    setLoading(false);
  }, [handleLogout]);

  if (loading) {
    return <div>Loading...</div>;
  }



  return (
    <AppContext.Provider
      value={{
        isCollapsed,
        toggleSidebar,
        isAuthenticated,
        isAdmin,
        userRole,
        handleLogout,
      }}
    >
      <Router>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="app-container">
          <Routes>
            <Route
              element={
                <MainSidebar onLogout={handleLogout} isCollapsed={isCollapsed}>
                  <Outlet />
                </MainSidebar>
              }
            >
              <Route
                path="/"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View sidebarOpen={isCollapsed} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/view"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View sidebarOpen={isCollapsed} />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/addnew"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <AddNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/prepare"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <PrintPreview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/about"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <About />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/real-estate"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/real-estate/view"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/real-estate/addnew"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <AddNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/real-estate/prepare"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <PrintPreview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wanted"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wanted/view"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wanted/addnew"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <AddNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wanted/prepare"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <PrintPreview />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/others"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/others/view"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <View />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/others/addnew"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <AddNew />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/others/prepare"
                element={
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <PrintPreview />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/register" element={<PageUnderConstruction />} />
            <Route
              path="/forgot-password"
              element={<PageUnderConstruction />}
            />
            <Route
              path="*"
              element={
                <Navigate to={isAuthenticated ? "/" : "/login"} replace />
              }
            />
          </Routes>
        </div>
      </Router>
    </AppContext.Provider>
  );
};

export default App;
